
import React from 'react';
import { UserCheck } from 'lucide-react';

const AccessibilityIcon = ({ className }: { className?: string }) => {
  return <UserCheck className={`text-primary dark:text-white ${className || ''}`} />;
};

export default AccessibilityIcon;
